import {
  APP_SETTING_SAVE_LAYOUT_BEGIN,
  APP_SETTING_SAVE_LAYOUT_SUCCESS,
  APP_SETTING_SAVE_LAYOUT_FAILURE,
  APP_SETTING_SAVE_LAYOUT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function saveLayout(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_SAVE_LAYOUT_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/layout/`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_SAVE_LAYOUT_SUCCESS,
              data: res.data,
            });
            toast.success('Created Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_SAVE_LAYOUT_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_SAVE_LAYOUT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveLayoutError() {
  return {
    type: APP_SETTING_SAVE_LAYOUT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_SAVE_LAYOUT_BEGIN:
      return {
        ...state,
        saveLayoutPending: true,
        saveLayoutError: null,
      };

    case APP_SETTING_SAVE_LAYOUT_SUCCESS:
      return {
        ...state,
        saveLayoutPending: false,
        saveLayoutError: null,
        layouts: [...state.layouts, action.data],
      };

    case APP_SETTING_SAVE_LAYOUT_FAILURE:
      return {
        ...state,
        saveLayoutPending: false,
        saveLayoutError: action.data.error,
      };

    case APP_SETTING_SAVE_LAYOUT_DISMISS_ERROR:
      return {
        ...state,
        saveLayoutError: null,
      };

    default:
      return state;
  }
}
